import classNames from 'classnames'
import { getAccessibilityTag } from '../../config'
import { IconButton, IconButtonVariants } from '../button'
import { CrossIcon } from '../icon'
import styles from './Snackbar.module.scss'
import type { SnackbarProps } from './types'

export const Snackbar = ({
  className,
  closeButtonAriaLabel,
  label,
  dismissible,
  leadingAccessory,
  actionButton,
  children,
  onDismiss,
}: SnackbarProps) => {
  const closeAriaLabel = getAccessibilityTag('close')

  return (
    <div className={classNames(styles['pintxo-snackbar'], className)} role="alert">
      <div className={classNames(styles['pintxo-snackbar__box'], 'pintxo-elevation-floating')}>
        {leadingAccessory && (
          <div className={styles['pintxo-snackbar__box__leadingAccessory']}>{leadingAccessory}</div>
        )}
        <div className={styles['pintxo-snackbar__box__label']}>{label || children}</div>
        {actionButton && (
          <div className={styles['pintxo-snackbar__box__actionButton']}>{actionButton}</div>
        )}
        {dismissible && (
          <IconButton
            aria-label={closeButtonAriaLabel || closeAriaLabel}
            icon={CrossIcon}
            onClick={onDismiss}
            variant={IconButtonVariants.transparent}
          />
        )}
      </div>
    </div>
  )
}
